import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { useLocalStorage } from '../../hooks/useLocalStorage/useLocalStorage'
import { useApplicationVariantKey } from '../hooks/useApplicationVariants'

import { origins } from '../../constants'
import VotingContainer from './VotingContainer'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  card: {
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
  },
  cardHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  registrationLogoImage: {
    width: '100%',
  },
})
const useStyles = makeStyles(styles)

function useVotingOpen() {
  const reportAOriginIdentifier = useApplicationVariantKey(
    origins.reportAOriginIdentifier,
    'isVotingOpen',
  )

  const reportBOriginIdentifier = useApplicationVariantKey(
    origins.reportBOriginIdentifier,
    'isVotingOpen',
  )

  const reportCOriginIdentifier = useApplicationVariantKey(
    origins.reportCOriginIdentifier,
    'isVotingOpen',
  )

  return (
    [
      reportAOriginIdentifier,
      reportBOriginIdentifier,
      reportCOriginIdentifier,
    ].filter(Boolean).length > 0
  )
}

export default function VotingRoute() {
  const { team } = useParams()

  const slug = team

  const isVotingOpen = useVotingOpen()

  const [authorizationToken] = useLocalStorage(
    'teamVotingPageAuthorizationToken',
  )

  const [isAuthenticated, setAuthenticated] = useState(!!authorizationToken)

  const classes = useStyles()

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item md={10} lg={9} xl={8}>
            <VotingContainer
              authorizationToken={authorizationToken}
              isAuthenticated={isAuthenticated}
              isVotingOpen={isVotingOpen}
              setAuthenticated={setAuthenticated}
              slug={slug}
              origins={[
                origins.reportBOriginIdentifier,
                origins.reportCOriginIdentifier,
              ]}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
